import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { CLINICIAN } from 'src/app/utils/constants';

@Component({
  selector: 'site-modal',
  templateUrl: 'site-modal.html',
  styleUrls: ['./site-modal.scss'],
})
export class SiteModalPage {
  title = 'What is a Provider Site?';
  clinician: string = CLINICIAN;
  constructor(
    private docTitle: Title,
    private modalController: ModalController,
    private analyticsService: AnalyticsService,
  ) {
    // this.analyticsService.tagModalOpened('sitecode_info_modal');
    this.docTitle.setTitle(this.title);
  }

  dismiss() {
    this.modalController.dismiss();
  }
}
